import { render } from "./TableApiView.vue?vue&type=template&id=3c1b7d60&scoped=true"
import script from "./TableApiView.vue?vue&type=script&lang=js"
export * from "./TableApiView.vue?vue&type=script&lang=js"

import "./TableApiView.vue?vue&type=style&index=0&id=3c1b7d60&scoped=true&lang=css"

import exportComponent from "/Users/rhylton/Sites/projeto-obras/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c1b7d60"]])

export default __exports__